module.exports = __webpack_public_path__ + "static/media/poster.3f8590b1.png";